module.exports = __webpack_public_path__ + "static/media/icon-white.929e2590.svg";